<footer class="footer" id="footer-main">
  <div class="footer-content" id="footer-content">
    <div class="footer-copyright" id="footer-copyright">
  &copy; <span id="footer-year">{{ currentYear }}</span> Innovadoc IA. {{ translate('footer.rights') }}
  <span *ngIf="appVersion" class="footer-version" id="footer-version">— v{{ appVersion }}</span>
    </div>
    <div class="footer-links" id="footer-links">
      <a routerLink="/terms" class="footer-link" id="footer-terms">{{ translate('footer.terms') }}</a>
      <a routerLink="/privacy" class="footer-link" id="footer-privacy">{{ translate('footer.privacy') }}</a>
      <a href="#" class="footer-link" id="footer-contact">{{ translate('footer.contact') }}</a>
    </div>
  </div>
</footer>